import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Layout from './components/Layout';
import SecretCreator from './components/SecretCreator';
import SecretViewer from './components/SecretViewer';
import PasswordGenerator from './components/PasswordGenerator';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<SecretCreator />} />
          <Route path="/secret/:id" element={<SecretViewer />} />
          <Route path="/generator" element={<PasswordGenerator />} />
          {/* Catch-all route to redirect to home */}
          <Route path="*" element={<SecretCreator />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
